export default function AssetPickerController2(
  $scope,
  equipmentRepository
) {
  'ngInject';

  $scope.ok = function () {
    $uibModalInstance.close({
      yomomma: 'asdfasdf'
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.calculatePages = function () {
    $scope.pages = [];

    $scope.numPages = Math.ceil($scope.responseData.data.total / $scope.limit);

    //if the number of assets is lower then the limit, must be on the first page.
    if ($scope.responseData.data.cursor < $scope.limit) {
      $scope.currentPage = 1;
    } else
      //always return a page higher if not equally divisible
      $scope.currentPage = Math.ceil(
        $scope.responseData.data.cursor / $scope.limit
      );

    var concurrentPages = 3;

    var cursor = $scope.currentPage - Math.ceil(concurrentPages / 2);
    var addedPages = 0;

    if (cursor < 0) {
      cursor = 0;
    }

    $scope.showingLastPage = false;
    $scope.showingFirstPage = false;

    while ($scope.pages.length < concurrentPages) {
      if (cursor < $scope.numPages) {
        $scope.pages.push(cursor + 1);
        cursor++;

        if (cursor == 1) {
          $scope.showingFirstPage = true;
        }

        if (cursor == $scope.numPages) {
          $scope.showingLastPage = true;
        }
      } else {
        break;
      }
    }
  };

  $scope.selectPage = function (page) {
    $scope.selectedPage = page;
    $scope.search();
  };

  $scope.sinceForPage = function (page, limit) {
    return (page - 1) * limit;
  };

  $scope.search = function () {
    if ($scope.loading) {
      $scope.isDirty = true;
      return;
    }

    $scope.loading = true;
    $scope.isDirty = false;

    var queryString = '*';

    var options = {};
    options.limit = $scope.limit || 500;
    if ($scope.selectedPage) {
      options.since = $scope.sinceForPage($scope.selectedPage, $scope.limit);
    }

    equipmentRepository.getEquipmentSearch(queryString, options).then(
      function (response, status, headers) {
        $scope.responseData = response;
        $scope.loading = false;

        $scope.calculatePages();

        if ($scope.isDirty) {
          $scope.search();
        }
      },
      function (data) {
        $scope.responseData = data;
        $scope.loading = false;

        if ($scope.isDirty) {
          $scope.search();
        }
      }
    );
  };

  $scope.init = function () {
    $scope.search();
  };

  $scope.init();
}